import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdSettlementApi, SettlementQuery, SettlementView } from '../tokens/ed-settlement.token';

/**
 * REST implementation of the E-D Settlements API (PRD §3.8 / §2.5, EM-834/835).
 *
 *   GET /services/embedded/api/v1/ed/settlement?from&to
 *   GET /services/embedded/api/v1/ed/settlement/export?format=pdf|xlsx
 *
 * E-D-scoped server-side (Rule 22). REST-only (Rules 07/10). Bound to ED_SETTLEMENT.
 */
@Injectable({ providedIn: 'root' })
export class EdSettlementRestService implements EdSettlementApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/settlement`;

  getSettlements(query: SettlementQuery): Observable<SettlementView> {
    return this.http.get<SettlementView>(this.base, { params: this.toParams(query) });
  }

  exportSettlements(format: 'pdf' | 'xlsx', query: SettlementQuery): Observable<Blob> {
    let params = this.toParams(query).set('format', format);
    return this.http.get(`${this.base}/export`, { params, responseType: 'blob' });
  }

  private toParams(query: SettlementQuery): HttpParams {
    let params = new HttpParams();
    if (query?.from) params = params.set('from', query.from);
    if (query?.to) params = params.set('to', query.to);
    return params;
  }
}
